import Grid from '@material-ui/core/Grid';

import { useStyles } from './LayoutBase.styled';

/**
 * The two columns of the summary band: location info on the left, summary info on the right.
 * Copied from LayoutBase of V1 InventoryProfileLayout/ProfileSummary, which is deleted with V1.
 * ProfileSummary and the loading skeleton of ProfilePageLayout use it.
 * @param {Object} props
 * @param {React.ReactNode} props.locationInfo Company, location and status chip
 * @param {React.ReactNode} props.summaryInfo EntitySummary
 */
export const LayoutBase = ({ locationInfo, summaryInfo }) => {
  const classes = useStyles();

  return (
    <div className={classes.profileInfoBar}>
      <Grid alignItems="center" container justify="space-between" spacing={1}>
        <Grid item container spacing={2} alignItems="center" xs={7}>
          {locationInfo}
        </Grid>
        <Grid item xs={5} container justify="flex-end">
          {summaryInfo}
        </Grid>
      </Grid>
    </div>
  );
};
